export default __webpack_public_path__ + "static/media/IT.7af9cfcd.svg";